import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import ServiceSectionLkk from '../../components/ServiceSection/ServiceSectionLkk';
import CtafromSection from '../../components/CtafromSection/CtafromSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/mc-dencia-photos/BothLogos1.png'


const ServicePageLkk = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <PageTitle pageTitle={'Лекарски Консултативни Комисии'} pagesub={'Лекарски Консултативни Комисии'} />
            <ServiceSectionLkk hclass={"service_section_s2 s3 section-padding"} sliceEnd={6} showSectionTitle={false} AllServices={false} />
            <CtafromSection hclass={'ctafrom_section'} />
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />

        </Fragment>
    )
};
export default ServicePageLkk;
